var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWiper({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}.c{fill:#002455;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-65)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(65 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.2,24.186a29.173,29.173,0,0,0-15.4,0c-1.9-4.2-3.753-8.2-5.539-12.005a29.163,29.163,0,0,1,26.476,0C93.952,15.987,92.1,19.989,90.2,24.186Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M90.2,24.936a.75.75,0,0,1-.2-.027,28.423,28.423,0,0,0-15,0,.75.75,0,0,1-.882-.415c-1.661-3.677-3.42-7.489-5.534-12a.75.75,0,0,1,.339-.987,29.913,29.913,0,0,1,27.157,0,.75.75,0,0,1,.339.987c-2.115,4.506-3.873,8.318-5.534,12A.75.75,0,0,1,90.2,24.936ZM82.5,22.4a29.921,29.921,0,0,1,7.277.9c1.5-3.323,3.1-6.778,4.97-10.772a28.411,28.411,0,0,0-24.494,0c1.871,3.993,3.465,7.448,4.97,10.772A29.921,29.921,0,0,1,82.5,22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.2,24.186a29.173,29.173,0,0,0-15.4,0c-1.9-4.2-3.753-8.2-5.539-12.005a29.163,29.163,0,0,1,26.476,0C93.952,15.987,92.1,19.989,90.2,24.186Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M90.2,24.936a.75.75,0,0,1-.2-.027,28.423,28.423,0,0,0-15,0,.75.75,0,0,1-.882-.415c-1.661-3.677-3.42-7.489-5.534-12a.75.75,0,0,1,.339-.987,29.913,29.913,0,0,1,27.157,0,.75.75,0,0,1,.339.987c-2.115,4.506-3.873,8.318-5.534,12A.75.75,0,0,1,90.2,24.936ZM82.5,22.4a29.921,29.921,0,0,1,7.277.9c1.5-3.323,3.1-6.778,4.97-10.772a28.411,28.411,0,0,0-24.494,0c1.871,3.993,3.465,7.448,4.97,10.772A29.921,29.921,0,0,1,82.5,22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.82,10.472a.75.75,0,0,1-.644-.365L-.644.385A.75.75,0,0,1-.385-.644.75.75,0,0,1,.644-.385L6.463,9.337a.75.75,0,0,1-.643,1.135Z",
    transform: "translate(75.167 16.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.82,10.472a.75.75,0,0,1-.644-.365L-.644.385A.75.75,0,0,1-.385-.644.75.75,0,0,1,.644-.385L6.463,9.337a.75.75,0,0,1-.643,1.135Z",
    transform: "translate(80.434 16.275)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWiper);
export default __webpack_public_path__ + "static/media/icon_wiper.194ae1863cce4ce17b44788b0a44560a.svg";
export { ForwardRef as ReactComponent };